import {
  GET_GROUPINGS,
  GET_ITEMS,
  GET_FILTERED_ITEMS,
} from '../actions/const';

const initialState = {
  Groupings: [],
  Items: [],
  FilteredItems: [],
};

export default (state = initialState, action) => {
  const nextState = { ...state };

  switch (action.type) {
    case GET_GROUPINGS: {
      nextState.Groupings = action.payload.data;
      return nextState;
    }

    case GET_FILTERED_ITEMS: {
      const { payload: { query, assocs } } = action;
      const subjectGrouping = nextState.Groupings.find((x) => x.ID === 90);
      const allSubjectAssocs = subjectGrouping.DataListAssociations.map((x) => x.ID);

      const filtered = [];
      nextState.Items.forEach((item) => {
        let add = false;
        if (query !== '') {
          if (item.Name.toLowerCase().indexOf(query) > -1) {
            if (assocs.length > 0) {
              const inSubjects = assocs.filter((x) => allSubjectAssocs.indexOf(x) > -1);
              const notInSubjects = assocs.filter((x) => allSubjectAssocs.indexOf(x) === -1);
              let foundCount = 0;

              notInSubjects.forEach((x) => {
                if (item.Associations.indexOf(x) > -1) {
                  foundCount += 1;
                }
              });

              let foundOr = false;
              inSubjects.forEach((x) => {
                if (item.Associations.indexOf(x) > -1) {
                  foundOr = true;
                }
              });

              if (foundOr) {
                foundCount += 1;
              }

              if (foundCount === notInSubjects.length + (inSubjects.length > 0 ? 1 : 0)) {
                add = true;
              }
            } else {
              add = true;
            }
          }
        } else if (assocs.length > 0) {
          const inSubjects = assocs.filter((x) => allSubjectAssocs.indexOf(x) > -1);
          const notInSubjects = assocs.filter((x) => allSubjectAssocs.indexOf(x) === -1);
          let foundCount = 0;

          notInSubjects.forEach((x) => {
            if (item.Associations.indexOf(x) > -1) {
              foundCount += 1;
            }
          });

          let foundOr = false;
          inSubjects.forEach((x) => {
            if (item.Associations.indexOf(x) > -1) {
              foundOr = true;
            }
          });

          if (foundOr) {
            foundCount += 1;
          }

          if (foundCount === notInSubjects.length + (inSubjects.length > 0 ? 1 : 0)) {
            add = true;
          }
        }

        if (add) {
          filtered.push(item);
        }
      });

      nextState.FilteredItems = filtered;
      return nextState;
    }

    case GET_ITEMS: {
      nextState.Items = action.payload.data;
      return nextState;
    }

    default: {
      return state;
    }
  }
};
